window.slate = window.slate || {};
window.theme = window.theme || {};
// somewhere to store custom global functions
window.rfd = window.rfd || {};

/*================ Slate ===================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects if focusing a link, just $link.focus();
	 *
	 * @param {JQuery} $element - The element to be acted upon
	 */
	pageLinkFocus: function ($element) {
		var focusClass = 'js-focus-hidden';

		$element
			.first()
			.attr('tabIndex', '-1')
			.focus()
			.addClass(focusClass)
			.one('blur', callback);

		function callback() {
			$element.first().removeClass(focusClass).removeAttr('tabindex');
		}
	},

	/**
	 * If there's a hash in the url, focus the appropriate element
	 */
	focusHash: function () {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
	 * When an in-page (url w/hash) link is clicked, focus the appropriate element
	 */
	bindInPageLinks: function () {
		$('a[href*=#]').on(
			'click',
			function (evt) {
				this.pageLinkFocus($(evt.currentTarget.hash));
			}.bind(this)
		);
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	trapFocus: function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function (evt) {
			if (
				options.$container[0] !== evt.target &&
				!options.$container.has(evt.target).length
			) {
				options.$container.focus();
			}
		});
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	removeTrapFocus: function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	},
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function () {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled) {
			document.cookie = 'testcookie';
			cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
		}
		return cookieEnabled;
	},
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function (array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function (array, key, value) {
		var i = array.length;
		while (i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function (array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function (value, defaultValue) {
		return value == null || value !== value ? defaultValue : value;
	},

	/**
	 * debounce function
	 * https://davidwalsh.name/javascript-debounce-function
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing.
	 */
	debounce: function (func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},

	/**
	 * throttle function
	 * https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
	 */
	throttle: function (func, limit) {
		var lastFunc;
		var lastRan;
		return function () {
			var context = this;
			var args = arguments;
			if (!lastRan) {
				func.apply(context, args);
				lastRan = Date.now();
			} else {
				clearTimeout(lastFunc);
				lastFunc = setTimeout(function () {
					if (Date.now() - lastRan >= limit) {
						func.apply(context, args);
						lastRan = Date.now();
					}
				}, limit - (Date.now() - lastRan));
			}
		};
	},
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTable: function (options) {
		var tableWrapperClass =
			typeof options.tableWrapperClass === 'undefined'
				? ''
				: options.tableWrapperClass;

		options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function (options) {
		var iframeWrapperClass =
			typeof options.iframeWrapperClass === 'undefined'
				? ''
				: options.iframeWrapperClass;

		options.$iframes.each(function () {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	},
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function (container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container,
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function (evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);
	},

	_onSelect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function (evt) {
		var instance = slate.utils.findInstance(
			this.instances,
			'id',
			evt.detail.sectionId
		);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function (type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(
			function (index, container) {
				this._createInstance(container, constructor);
			}.bind(this)
		);
	},
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands
			);
			var centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney,
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(
			/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
		);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(
			/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
		);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol,
	};
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-ctrl-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]',
		monogrammer: '[data-monogrammer]',
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse(
			$(selectors.productJson, this.$container).html()
		);

		var options = {
			$container: this.$container,
			enableHistoryState:
				this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject,
		};

		this.settings = {};
		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(
			selectors.productFeaturedImage,
			this.$container
		);

		this.$container.on(
			'variantChange' + this.namespace,
			this.updateAddToCartState.bind(this)
		);
		this.$container.on(
			'variantPriceChange' + this.namespace,
			this.updateProductPrices.bind(this)
		);

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(
				this.$featuredImage.attr('src')
			);
			slate.Image.preload(
				this.productSingleObject.images,
				this.settings.imageSize
			);

			this.$container.on(
				'variantImageChange' + this.namespace,
				this.updateProductImage.bind(this)
			);
		}
	}

	Product.prototype = $.extend({}, Product.prototype, {
		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function (evt) {
			var variant = evt.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				$(selectors.monogrammer, this.$container).removeClass(
					'hide',
					false
				);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(
					theme.strings.unavailable
				);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				$(selectors.monogrammer, this.$container).addClass('hide');
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);

				// PURPLE DOT: COMMENTED OUT TO HIDE AN UNRELATED PREORDER FUNC
				// if ($(selectors.addToCart).data('preorder') === true) {
				//   $(selectors.addToCartText, this.$container).html(theme.strings.preorder);
				// } else {
				//   $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
				// }
				$(selectors.addToCartText, this.$container).html(
					theme.strings.addToCart
				);
				// END PURPLE DOT

				$(selectors.monogrammer, this.$container).removeClass('hide');
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(
					theme.strings.soldOut
				);
				$(selectors.monogrammer, this.$container).addClass('hide');
			}
		},
		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);
		},
	});

	return Product;
})();

// OLD FOR STORAGE

// Variants are not selectable
//
// if (BIS.urlIsProductPage() === true) {
// 	BISPopover.ready.then(function() {

// 	  // Exit script if product has no sold out variants.
// 	  if (BIS.popup.variants.length < 1) {
// 		return;
// 	  }

// 	  if (BIS.popup.product.available)  {
// 		var button = $('<a>', {
// 		  text: 'Size out of stock? Click here',
// 		  href: '#',
// 		  id: 'BIS_trigger',
// 		  class: '',
// 		  css: {
// 			display: 'inline-block',
// 			margin: '-25px 0 20px 0',
// 			fontSize: '12px'
// 		  }
// 		});
// 		BIS.inlineButtonAnchor = $('button[data-add-to-cart]')
// 		BIS.inlineButtonAnchor.eq(0).before(button);
// 	  } else {
// 		 var button = $('<button>', {
// 		   text: BIS.Config.button.caption,
// 		   href: '#',
// 		   id: 'BIS_trigger',
// 		  class: 'btn button',
// 		   css: {
// 			 // display: 'block',
// 			 textAlign: 'center',
// 			 margin: '10px 0 0 0',
// 			 width: '287.25px'
// 		   }
// 		 });
// 		 BIS.inlineButtonAnchor = $('form[action="/cart/add"]')
// 		 BIS.inlineButtonAnchor.eq(0).after(button);
// 	  }

// 	});
//   }
